// extracted by mini-css-extract-plugin
module.exports = {"groupItem":"_3bBLp","isActive":"_2JpMf","icon":"_1MY8b","isIconActive":"_1KpD_"};